import { useEffect } from "react";
import APP_LINKS from "../assets/AppLinks";

const { APP_STORE_URL, PLAY_STORE_URL, WEB_URL } = APP_LINKS;

export default function DownloadApp() {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || "";

    if (/android/i.test(userAgent)) {
      window.location.replace(PLAY_STORE_URL);
      return;
    };

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      window.location.replace(APP_STORE_URL);
      return;
    };

    window.location.replace(WEB_URL);
  }, []);

  return <div
  style={{
    textAlign: "center"
  }}
  >
    Redirecting...
  </div>;
};